"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
const js_brand_1 = require("@giphy/js-brand");
const hooks_1 = require("preact/hooks");
const preact_1 = require("preact");
const useRaf = (ms = 1e12, delay = 0) => {
    const [elapsed, set] = (0, hooks_1.useState)(0);
    (0, hooks_1.useLayoutEffect)(() => {
        let raf;
        let timerStop;
        let start;
        const onFrame = () => {
            const time = Math.min(1, (Date.now() - start) / ms);
            set(time);
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            loop();
        };
        const loop = () => {
            raf = requestAnimationFrame(onFrame);
        };
        const onStart = () => {
            timerStop = setTimeout(() => {
                cancelAnimationFrame(raf);
                set(1);
            }, ms);
            start = Date.now();
            loop();
        };
        const timerDelay = setTimeout(onStart, delay);
        return () => {
            clearTimeout(timerStop);
            clearTimeout(timerDelay);
            cancelAnimationFrame(raf);
        };
    }, [ms, delay]);
    return elapsed;
};
const barCss = (0, css_1.css) `
    background: ${js_brand_1.giphyWhite};
    height: 2px;
    position: absolute;
    width: 5px;
    bottom: 0;
    left: 0;
    opacity: 0.95;
`;
const ProgressBar = ({ videoEl }) => {
    const [progress, setProgress] = (0, hooks_1.useState)(0);
    useRaf(2147483647, 100);
    const time = (videoEl === null || videoEl === void 0 ? void 0 : videoEl.currentTime) || 0;
    const duration = (videoEl === null || videoEl === void 0 ? void 0 : videoEl.duration) || 0;
    const val = time / duration;
    (0, hooks_1.useLayoutEffect)(() => {
        setProgress(val);
    }, [val, setProgress]);
    let perc = Math.round(progress * 100);
    perc = duration < 10 && perc > 98 ? 100 : perc;
    return (0, preact_1.h)("div", { style: { width: `${perc}%` }, className: barCss });
};
exports.default = ProgressBar;
//# sourceMappingURL=progress-bar.js.map